import AWS from 'aws-sdk';

//Cloudfront
// const getCloudFrontUrl = (key) => {
//   const cloudFrontBaseUrl = process.env.REACT_APP_CLOUDFRONT_URL;
//   return `${cloudFrontBaseUrl}/${key}`;
// };

// export { getCloudFrontUrl };

//S3
AWS.config.update({
  accessKeyId: process.env.REACT_APP_AWS_ACCESS_KEY_ID,
  secretAccessKey: process.env.REACT_APP_AWS_SECRET_ACCESS_KEY,
  region: process.env.REACT_APP_AWS_REGION,
});

const s3 = new AWS.S3();

const listObjectsInBucket = async (bucketName, prefix) => {
  const params = {
    Bucket: bucketName,
    Prefix: prefix
  };
  return s3.listObjectsV2(params).promise();
};

export { s3, listObjectsInBucket };

/*
Code to test to leverage cloudfront
import AWS from "aws-sdk";
import express from "express";
import dotenv from "dotenv";

dotenv.config();

const app = express();
const s3 = new AWS.S3({
  accessKeyId: process.env.AWS_ACCESS_KEY_ID,
  secretAccessKey: process.env.AWS_SECRET_ACCESS_KEY,
  region: process.env.AWS_REGION,
});

app.get("/api/list-objects", async (req, res) => {
  const { prefix } = req.query;

  try {
    const params = {
      Bucket: process.env.AWS_S3_BUCKET_NAME,
      Prefix: prefix,
    };
    const data = await s3.listObjectsV2(params).promise();

    // Convert S3 URLs to CloudFront URLs
    const cloudFrontDomain = process.env.CLOUDFRONT_URL; // e.g., "https://d123xyz.cloudfront.net"
    const objects = data.Contents.map(obj => ({
      key: obj.Key,
      url: `${cloudFrontDomain}/${obj.Key}`
    }));

    res.json(objects);
  } catch (error) {
    res.status(500).json({ error: error.message });
  }
});

app.listen(3001, () => console.log("Server running on port 3001"));
 */